import { AdminLegendVariant, getAdminEvent } from '@pharmaplan/common';
import { adminCalendarParams } from '../../selectors/calendarSelector';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

const useAdminEvent = () => {
  const dispatch = useAppDispatch();
  const params = useAppSelector(adminCalendarParams);

  const getAdminEventByDate = ({
    selectedDate,
    type,
  }: {
    selectedDate: string;
    type: AdminLegendVariant;
  }) => {
    const { softwareId, startTime, endTime, banners } = params ?? {};

    dispatch(
      getAdminEvent({
        selectedDate,
        type,
        softwareId,
        startTime,
        endTime,
        banners,
      }),
    );
  };

  return { getAdminEventByDate };
};

export default useAdminEvent;
